(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5545],{

/***/ 64673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BackgroundBannerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29260);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var BackgroundBannerImage = function(param) {
    var _layout = param.layout, layout = _layout === void 0 ? "fill" : _layout, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _priority = param.priority, priority = _priority === void 0 ? true : _priority, className = param.className;
    // TODO: update blue_banner.svg to not be massive and refactor this component to use <BlueBanner /> instead.
    //       Current implementation clashes with loki visual regression testing - stopping us from using this component in our stories
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: className,
        src: "/blue_banner.svg",
        layout: layout,
        objectFit: objectFit,
        alt: alt,
        priority: priority
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundBannerImage);


/***/ }),

/***/ 38303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ LinearProgressBar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50253);
/* harmony import */ var _material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33681);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);






var LinearProgressBar = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "flex",
        alignItems: "center",
        mb: 1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                width: "100%",
                mr: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    variant: "determinate"
                }, props))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                minWidth: 35,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "body2",
                    color: "textSecondary",
                    children: "".concat(Math.round(props.value), "%")
                })
            })
        ]
    });
};


/***/ }),

/***/ 81391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bh": function() { return /* binding */ PhoneNumber; },
/* harmony export */   "aI": function() { return /* binding */ phoneNumberSchema; }
/* harmony export */ });
/* unused harmony export phoneList */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_customisedYup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79427);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96394);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66851);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85639);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39803);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56411);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var Other = "other";
var phoneList = [
    {
        text: "AUS (+61)",
        value: "+61"
    },
    {
        text: "NZL (+64)",
        value: "+64"
    },
    {
        text: "CAN (+01)",
        value: "+01"
    },
    {
        text: "UK (+44)",
        value: "+44"
    },
    {
        text: "USA (+01)",
        value: "+01"
    },
    {
        text: "IRE (+353)",
        value: "+353"
    },
    {
        text: "Other",
        value: Other
    }, 
];
var phoneNumberLengthHint = "Min length is 6, and Max length is 20.";
var phoneNumberValidHint = "A valid phone number only contain '+' symbol and numeric values";
var phoneNumberCountryCodeHint = "A valid phone number must contain country code e.g '+64'";
var phoneNumberSchema = _utils_customisedYup__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .Z.string().trim().min(6, phoneNumberLengthHint).max(20, phoneNumberLengthHint).matches(/^[\d+]*$/, phoneNumberValidHint).matches(/^\+[\d]{1,20}$/, phoneNumberCountryCodeHint).required();
var PhoneNumber = function(param) {
    var error = param.error, area = param.area, phoneNumber = param.phoneNumber, onChange = param.onChange, _showArea = param.showArea, showArea = _showArea === void 0 ? true : _showArea, _showRequired = param.showRequired, showRequired = _showRequired === void 0 ? false : _showRequired;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        area: area || phoneList[0].value,
        phone: ""
    }), newPhone = ref[0], setNewPhone = ref[1];
    var orgnizePhoneNumber = function(area, phone) {
        phone = phone.replace(/^0+/, "");
        return {
            area: area,
            phone: phone,
            mixPhone: "".concat(!showArea || area === Other ? "" : area).concat(phone)
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showArea && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().phoneArea),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        id: "area-code-select-label"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        labelId: "area-code-select-label",
                        id: "area-code-select",
                        inputProps: {
                            "data-testid": "area-code-select"
                        },
                        value: newPhone.area,
                        autoWidth: true,
                        onChange: function(e) {
                            setNewPhone((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, newPhone), {
                                area: e.target.value + ""
                            }));
                            onChange(orgnizePhoneNumber(e.target.value, newPhone.phone));
                        },
                        children: phoneList.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                value: item.value,
                                children: item.text
                            }, item.text);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().phoneNumber),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    required: showRequired,
                    label: newPhone.area === Other ? "Enter phone number with country code" : "Phone number",
                    name: "phoneNumber",
                    id: "phoneNumber",
                    inputProps: {
                        "data-testid": "phone-number"
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().phoneNumber),
                    fullWidth: true,
                    defaultValue: phoneNumber,
                    error: !!error,
                    onChange: function(e) {
                        setNewPhone((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, newPhone), {
                            phone: e.target.value
                        }));
                        onChange(orgnizePhoneNumber(newPhone.area, e.target.value));
                    },
                    helperText: error
                })
            })
        ]
    });
};


/***/ }),

/***/ 55827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ProgressBarLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87113);
/* harmony import */ var _components_LinearProgressBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38303);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41749);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6117);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var ProgressBarLayout = function(param) {
    var children = param.children, divide = param.divide, img = param.img, imgAlt = param.imgAlt, leftContent = param.leftContent, progress = param.progress, blueBackground = param.blueBackground;
    if (divide) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mainContainer), blueBackground && (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().blueBackground)),
            children: [
                progress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().progressBar),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinearProgressBar__WEBPACK_IMPORTED_MODULE_2__/* .LinearProgressBar */ .D, {
                        value: progress
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    container: true,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            item: true,
                            lg: 5,
                            xs: 12,
                            md: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("aside", {
                                children: leftContent || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: img || "",
                                    alt: imgAlt || _components_Image__WEBPACK_IMPORTED_MODULE_1__/* .defaultAlt */ .Zp
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            item: true,
                            lg: 7,
                            xs: 12,
                            md: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().rightContent),
                                children: children
                            })
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mainContainer),
        children: children
    });
};


/***/ }),

/***/ 35545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ RegisterBasicInfo_RegisterBasicInfo; },
  "oe": function() { return /* binding */ emailLengthHint; },
  "qP": function() { return /* binding */ firstNameLengthHint; },
  "O8": function() { return /* binding */ lastNameLengthHint; }
});

// UNUSED EXPORTS: defaultOverlayCenteredText

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./constants/commonPasswords.ts
// This list was downloaded from https://github.com/danielmiessler/SecLists/blob/master/Passwords/Common-Credentials/10k-most-common.txt
// Currently the minimum password length is 8 characters so we've removed entries that are shorter than 8 characters before pasting it here.
// Using a Set for faster lookups.
var commonPasswords = new Set([
    "password",
    "12345678",
    "baseball",
    "football",
    "jennifer",
    "superman",
    "trustno1",
    "michelle",
    "sunshine",
    "123456789",
    "starwars",
    "computer",
    "corvette",
    "princess",
    "iloveyou",
    "maverick",
    "samantha",
    "steelers",
    "whatever",
    "hardcore",
    "internet",
    "mercedes",
    "bigdaddy",
    "midnight",
    "11111111",
    "marlboro",
    "victoria",
    "butthead",
    "startrek",
    "liverpoo",
    "danielle",
    "redskins",
    "mountain",
    "shithead",
    "xxxxxxxx",
    "88888888",
    "nicholas",
    "metallic",
    "qwertyui",
    "dolphins",
    "cocacola",
    "rush2112",
    "jonathan",
    "scorpion",
    "asdfasdf",
    "godzilla",
    "williams",
    "lifehack",
    "platinum",
    "garfield",
    "69696969",
    "jordan23",
    "bullshit",
    "airborne",
    "elephant",
    "explorer",
    "christin",
    "december",
    "benjamin",
    "dickhead",
    "brooklyn",
    "redwings",
    "michigan",
    "87654321",
    "guinness",
    "einstein",
    "snowball",
    "alexande",
    "passw0rd",
    "lasvegas",
    "slipknot",
    "kimberly",
    "1q2w3e4r",
    "carolina",
    "colorado",
    "creative",
    "bollocks",
    "darkness",
    "asdfghjk",
    "poohbear",
    "nintendo",
    "november",
    "password1",
    "lacrosse",
    "paradise",
    "maryjane",
    "spitfire",
    "anderson",
    "cherokee",
    "drowssap",
    "marshall",
    "1qaz2wsx",
    "caroline",
    "franklin",
    "snickers",
    "courtney",
    "westside",
    "patricia",
    "semperfi",
    "freeuser",
    "babygirl",
    "champion",
    "softball",
    "security",
    "wildcats",
    "veronica",
    "abcd1234",
    "wolverin",
    "remember",
    "freepass",
    "pearljam",
    "mistress",
    "peekaboo",
    "budlight",
    "electric",
    "stargate",
    "brittany",
    "swimming",
    "scotland",
    "swordfis",
    "blink182",
    "virginia",
    "passport",
    "aaaaaaaa",
    "rolltide",
    "bulldogs",
    "liverpool",
    "chevelle",
    "mitchell",
    "spiderma",
    "patriots",
    "cardinal",
    "kawasaki",
    "ncc1701d",
    "airplane",
    "scarface",
    "elizabet",
    "wolfpack",
    "lawrence",
    "american",
    "stingray",
    "simpsons",
    "srinivas",
    "panthers",
    "pussycat",
    "loverboy",
    "tarheels",
    "wolfgang",
    "testtest",
    "michael1",
    "pakistan",
    "infinity",
    "letmein1",
    "hercules",
    "billybob",
    "pavilion",
    "changeme",
    "darkside",
    "zeppelin",
    "darkstar",
    "charlie1",
    "wrangler",
    "qwerty12",
    "bobafett",
    "business",
    "sterling",
    "babydoll",
    "cheyenne",
    "longhorn",
    "presario",
    "mustang1",
    "21122112",
    "q1w2e3r4",
    "12341234",
    "devildog",
    "bluebird",
    "metallica",
    "access14",
    "enterpri",
    "blizzard",
    "asdf1234",
    "harrison",
    "thailand",
    "1234567890",
    "cadillac",
    "hellfire",
    "lonewolf",
    "12121212",
    "fireball",
    "precious",
    "engineer",
    "basketba",
    "valentin",
    "wetpussy",
    "morpheus",
    "hotstuff",
    "fuck_inside",
    "goldberg",
    "wrinkle1",
    "consumer",
    "serenity",
    "99999999",
    "bigboobs",
    "chocolat",
    "christia",
    "birthday",
    "stephani",
    "1234qwer",
    "98765432",
    "77777777",
    "highland",
    "seminole",
    "airforce",
    "hamilton",
    "buckeyes",
    "abcdefgh",
    "goldfish",
    "deftones",
    "icecream",
    "pleasure",
    "juventus",
    "ncc1701e",
    "51505150",
    "cavalier",
    "aardvark",
    "babylon5",
    "savannah",
    "yankees1",
    "fredfred",
    "concrete",
    "shamrock",
    "atlantis",
    "wordpass",
    "predator",
    "marathon",
    "montreal",
    "kathleen",
    "jessica1",
    "diamonds",
    "stallion",
    "letmein2",
    "clitoris",
    "sundance",
    "renegade",
    "hollywoo",
    "hello123",
    "sweetpea",
    "stocking",
    "campbell",
    "christop",
    "rockstar",
    "geronimo",
    "chandler",
    "lovelove",
    "greenday",
    "987654321",
    "creampie",
    "trombone",
    "55555555",
    "mongoose",
    "tottenha",
    "butterfl",
    "clifford",
    "fuckyou2",
    "infantry",
    "skywalke",
    "raistlin",
    "vanhalen",
    "sherlock",
    "dietcoke",
    "ultimate",
    "superfly",
    "freedom1",
    "drpepper",
    "lesbians",
    "musicman",
    "warcraft",
    "microsoft",
    "morrison",
    "isabelle",
    "thuglife",
    "stonecol",
    "logitech",
    "florence",
    "1passwor",
    "bluemoon",
    "22222222",
    "stardust",
    "margaret",
    "66666666",
    "charlott",
    "waterloo",
    "11223344",
    "standard",
    "alexandr",
    "hannibal",
    "frontier",
    "welcome1",
    "spanking",
    "japanese",
    "kristina",
    "deepthroat",
    "bonehead",
    "showtime",
    "squirrel",
    "mustangs",
    "septembe",
    "leonardo",
    "makaveli",
    "vacation",
    "passwor1",
    "columbia",
    "napoleon",
    "motorola",
    "william1",
    "matthew1",
    "robinson",
    "penguins",
    "8j4ye3uz",
    "californ",
    "qwertyuiop",
    "portland",
    "asdfghjkl",
    "overlord",
    "stranger",
    "socrates",
    "spiderman",
    "13131313",
    "national",
    "intrepid",
    "megadeth",
    "bigballs",
    "chargers",
    "discover",
    "isabella",
    "megapass",
    "grateful",
    "mushroom",
    "cristina",
    "hongkong",
    "basketball",
    "satan666",
    "kingkong",
    "penelope",
    "thompson",
    "anything",
    "knickers",
    "playtime",
    "lightnin",
    "slapshot",
    "titleist",
    "werewolf",
    "fernando",
    "blackcat",
    "tacobell",
    "kittycat",
    "thunder1",
    "thankyou",
    "scoobydo",
    "coltrane",
    "lonestar",
    "heather1",
    "beefcake",
    "zzzzzzzz",
    "personal",
    "anthony1",
    "fuckface",
    "lowrider",
    "punkrock",
    "dodgeram",
    "dingdong",
    "qqqqqqqq",
    "johnjohn",
    "asshole1",
    "crusader",
    "syracuse",
    "meridian",
    "turkey50",
    "keyboard",
    "ilovesex",
    "blackman",
    "richmond",
    "sandiego",
    "cooldude",
    "mariners",
    "caliente",
    "fletcher",
    "porsche9",
    "kangaroo",
    "springer",
    "goodtime",
    "chelsea1",
    "freckles",
    "nebraska",
    "webmaster",
    "blueeyes",
    "director",
    "monopoly",
    "blackjac",
    "southern",
    "peterpan",
    "fuckyou1",
    "a1b2c3d4",
    "sentinel",
    "richard1",
    "1234abcd",
    "guardian",
    "candyman",
    "mandingo",
    "munchkin",
    "billyboy",
    "rootbeer",
    "assassin",
    "frederic",
    "giovanni",
    "scarlett",
    "achilles",
    "warriors",
    "plymouth",
    "cameltoe",
    "fuckfuck",
    "sithlord",
    "backdoor",
    "chevrole",
    "lorraine",
    "cosworth",
    "eternity",
    "verbatim",
    "chocolate",
    "deadhead",
    "pineappl",
    "rosemary",
    "porkchop",
    "blackdog",
    "alexander",
    "valhalla",
    "santiago",
    "portugal",
    "1qazxsw2",
    "stripper",
    "sebastia",
    "hurrican",
    "1x2zkg8w",
    "atlantic",
    "hyperion",
    "44444444",
    "skittles",
    "hastings",
    "gangbang",
    "sailboat",
    "immortal",
    "maryland",
    "columbus",
    "beautiful",
    "swordfish",
    "ncc1701a",
    "spartans",
    "threesom",
    "dilligaf",
    "pinkfloy",
    "catalina",
    "formula1",
    "scooter1",
    "colombia",
    "lancelot",
    "angelica",
    "rockhard",
    "poontang",
    "starship",
    "starbuck",
    "catherin",
    "kentucky",
    "33333333",
    "12344321",
    "sapphire",
    "raiders1",
    "excalibu",
    "imperial",
    "phillips",
    "golfball",
    "front242",
    "macdaddy",
    "qwer1234",
    "cowboys1",
    "dannyboy",
    "martinez",
    "aquarius",
    "pppppppp",
    "clarence",
    "eatpussy",
    "beatrice",
    "phillies",
    "research",
    "gggggggg",
    "doughboy",
    "lollipop",
    "qazwsxed",
    "crazybab",
    "brothers",
    "butthole",
    "rightnow",
    "greatone",
    "gateway1",
    "wildfire",
    "jackson1",
    "0.0.0.000",
    "snuggles",
    "phoenix1",
    "technics",
    "gesperrt",
    "brucelee",
    "woofwoof",
    "theodore",
    "richards",
    "punisher",
    "username",
    "bunghole",
    "elizabeth",
    "lifetime",
    "masterbate",
    "diamond1",
    "abnormal",
    "davidson",
    "starfish",
    "penetration",
    "michaela",
    "caligula",
    "railroad",
    "bradford",
    "military",
    "bearbear",
    "patrick1",
    "christine",
    "swinging",
    "labrador",
    "justdoit",
    "meatball",
    "saturday",
    "defender",
    "piercing",
    "microsof",
    "mechanic",
    "robotech",
    "universe",
    "newpass6",
    "hellyeah",
    "zaq12wsx",
    "spectrum",
    "jjjjjjjj",
    "oklahoma",
    "mmmmmmmm",
    "blueblue",
    "wolverine",
    "sniffing",
    "keystone",
    "bbbbbbbb",
    "handsome",
    "tttttttt",
    "ssssssss",
    "somethin",
    "melissa1",
    "marcius2",
    "godsmack",
    "rangers1",
    "deeznuts",
    "kingston",
    "yosemite",
    "tommyboy",
    "masterbating",
    "marianne",
    "happyday",
    "manchest",
    "unbelievable",
    "aberdeen",
    "nathalie",
    "intercourse",
    "supersta",
    "bcfields",
    "hardrock",
    "children",
    "commando",
    "sinclair",
    "squerting",
    "jeanette",
    "meathead",
    "gandalf1",
    "magnolia",
    "kenworth",
    "redalert",
    "homemade",
    "webmaste",
    "insertion",
    "temptress",
    "gretchen",
    "celebrity",
    "ragnarok",
    "trinidad",
    "kingfish",
    "blackhaw",
    "thursday",
    "meatloaf",
    "interacial",
    "streaming",
    "pertinant",
    "pool6123",
    "animated",
    "gordon24",
    "fantasies",
    "touching",
    "homepage",
    "ejaculation",
    "whocares",
    "jamesbon",
    "amsterda",
    "february",
    "luckydog",
    "businessbabe",
    "brandon1",
    "experience",
    "software",
    "thirteen",
    "rasputin",
    "greenbay",
    "pa55word",
    "contortionist",
    "sneakers",
    "sonyfuck",
    "test1234",
    "roadkill",
    "cheerleaers",
    "madeline",
    "christian",
    "brighton",
    "housewifes",
    "emmanuel",
    "bigmoney",
    "seductive",
    "sexygirl",
    "canadian",
    "gangbanged",
    "crawford",
    "hotpussy",
    "implants",
    "intruder",
    "andyod22",
    "barcelon",
    "chainsaw",
    "chickens",
    "downtown",
    "magicman",
    "clevelan",
    "designer",
    "budweise",
    "experienced",
    "pitchers",
    "passwords",
    "jeremiah",
    "alliance",
    "halflife",
    "saratoga",
    "positive",
    "transexual",
    "close-up",
    "sunnyday",
    "starfire",
    "pictuers",
    "testing1",
    "tiberius",
    "lisalisa",
    "golfgolf",
    "flounder",
    "majestic",
    "trailers",
    "mikemike",
    "whitesox",
    "angelina",
    "goodluck",
    "charlton",
    "fingerig",
    "gallaries",
    "lockerroom",
    "treasure",
    "absolutely",
    "homepage-",
    "beerbeer",
    "testerer",
    "fordf150",
    "pa55w0rd",
    "kamikaze",
    "japanees",
    "masterbaiting",
    "callaway",
    "panasoni",
    "housewife",
    "18436572",
    "sullivan",
    "terrapin",
    "masturbation",
    "hardcock",
    "freeporn",
    "pornographic",
    "traveler",
    "moneyman",
    "shopping",
    "thumbnils",
    "amateurs",
    "apollo13",
    "goldwing",
    "doghouse",
    "pounding",
    "truelove",
    "underdog",
    "wrestlin",
    "sherwood",
    "johannes",
    "balloons",
    "happy123",
    "flamingo",
    "paintbal",
    "llllllll",
    "twilight",
    "christie",
    "bullseye",
    "knickerless",
    "binladen",
    "peterson",
    "thanatos",
    "albatros",
    "getsdown",
    "nwo4life",
    "underwear",
    "dddddddd",
    "deeznutz",
    "enterprise",
    "misfit99",
    "solution",
    "meredith",
    "barefoot",
    "50spanks",
    "scandinavian",
    "original",
    "shannon1",
    "techniques",
    "chemical",
    "salvador",
    "manchester",
    "buckshot",
    "thegreat",
    "goldstar",
    "triangle",
    "kristine",
    "snowboar",
    "penetrating",
    "roadking",
    "rockford",
    "chicago1",
    "ferrari1",
    "galeries",
    "godfathe",
    "gargoyle",
    "gangster",
    "pussyman",
    "pooppoop",
    "newcastl",
    "mortgage",
    "snoopdog",
    "assholes",
    "property",
    "broadway",
    "butterfly",
    "earthlink",
    "westwood",
    "blackbir",
    "slippery",
    "pianoman",
    "tomorrow",
    "roadrunn",
    "attitude",
    "seahawks",
    "tunafish",
    "cinnamon",
    "northern",
    "23232323",
    "zerocool",
    "limewire",
    "films+pic+galeries",
    "francois",
    "fuckthis",
    "girfriend",
    "uncencored",
    "chrisbln",
    "netscape",
    "hhhhhhhh",
    "knockers",
    "tazmania",
    "pharmacy",
    "arsenal1",
    "anaconda",
    "australi",
    "gotohell",
    "bulldog1",
    "monalisa",
    "whiteout",
    "james007",
    "bitchass",
    "southpar",
    "lionking",
    "megatron",
    "hawaiian",
    "gymnastic",
    "panther1",
    "wp2003wp",
    "passwort",
    "friendly",
    "oooooooo",
    "bullfrog",
    "holyshit",
    "jasmine1",
    "sergeant",
    "babyblue",
    "pass1234",
    "poseidon",
    "confused",
    "hollywood",
    "insertions",
    "juliette",
    "hayabusa",
    "hawkeyes",
    "geoffrey",
    "chuckles",
    "hounddog",
    "philippe",
    "thunderb",
    "marino13",
    "handyman",
    "cerberus",
    "gamecock",
    "magician",
    "preacher",
    "chrysler",
    "contains",
    "hedgehog",
    "hoosiers",
    "dutchess",
    "wareagle",
    "ihateyou",
    "sunflowe",
    "senators",
    "terminal",
    "laurence",
    "maradona",
    "america1",
    "chicken1",
    "passpass",
    "r2d2c3po",
    "myxworld",
    "missouri",
    "wishbone",
    "infiniti",
    "wonderboy",
    "stanford",
    "smeghead",
    "titanium",
    "charlene",
    "fishing1",
    "fullmoon",
    "absolute",
    "seinfeld",
    "pingpong",
    "matthews",
    "recovery",
    "babyface",
    "gladiato",
    "paranoid",
    "packers1",
    "longjohn",
    "clarinet",
    "mortimer",
    "modelsne",
    "vladimir",
    "together",
    "avalanch",
    "55bgates",
    "cccccccc",
    "paradigm",
    "operator",
    "valencia",
    "cocksuck",
    "creature",
    "borussia",
    "browning",
    "heritage",
    "millions",
    "starcraf",
    "spaceman",
    "chester1",
    "rrrrrrrr",
    "sandwich",
    "magazine",
    "buttfuck",
    "yeahbaby",
    "11235813",
    "bangbang",
    "charles1",
    "ffffffff",
    "doberman",
    "overkill",
    "claymore",
    "brewster",
    "electron",
    "eastside",
    "minimoni",
    "wildbill",
    "wildcard",
    "yyyyyyyy",
    "sweetnes",
    "skywalker",
    "alphabet",
    "babybaby",
    "graphics",
    "florida1",
    "flexible",
    "fuckinside",
    "ursitesux",
    "christma",
    "wwwwwwww",
    "just4fun",
    "rebecca1",
    "adrienne",
    "19691969",
    "silverad",
    "rhiannon",
    "10101010",
    "ashleigh",
    "qwerasdf",
    "presiden",
    "newyork1",
    "brigitte",
    "buddyboy",
    "heineken",
    "millwall",
    "beautifu",
    "sinister",
    "smashing",
    "teddybea",
    "ticklish",
    "lipstick",
    "reynolds",
    "applepie",
    "digital1",
    "dinosaur",
    "icehouse",
    "insanity",
    "bluefish",
    "strength",
    "sentnece",
    "temppass",
    "medicine",
    "hahahaha",
    "casanova",
    "fountain",
    "dolphin1",
    "porsche1",
    "vampires",
    "highheel",
    "kkkkkkkk",
    "illinois",
    "21212121",
    "stonecold",
    "testpass",
    "jiggaman",
    "federico",
    "scorpio1",
    "rt6ytere",
    "madison1",
    "coolness",
    "christina",
    "coldbeer",
    "brittney",
    "washingt",
    "stephanie",
    "shepherd",
    "tiffany1",
    "mephisto",
    "dragonba",
    "nygiants",
    "password2",
    "corleone",
    "kittykat",
    "vikings1",
    "splinter",
    "pipeline",
    "meowmeow",
    "chestnut",
    "longdong",
    "quant4307s",
    "eastwood",
    "moonligh",
    "illusion",
    "jayhawks",
    "swingers",
    "stefanie",
    "jefferso",
    "michael2",
    "fastball",
    "scrabble",
    "dirtbike",
    "customer",
    "nemrac58",
    "bobdylan",
    "hopeless",
    "kcj9wx5n",
    "killbill",
    "volkswag",
    "windmill",
    "iloveyou1",
    "starligh",
    "soulmate",
    "mcdonald",
    "rochelle",
    "oblivion",
    "valkyrie",
    "concorde",
    "costello",
    "delaware",
    "nocturne",
    "herewego",
    "earnhard",
    "eeeeeeee",
    "mobydick",
    "reddevil",
    "reckless",
    "radiohea",
    "coolcool",
    "classics",
    "choochoo",
    "wireless",
    "bigblock",
    "summer99",
    "sexysexy",
    "platypus",
    "telephon",
    "12qwaszx",
    "fishhead",
    "paramedi",
    "lonesome",
    "katherin",
    "moonbeam",
    "monster1",
    "monkeybo",
    "windsurf",
    "31415926",
    "sebastian",
    "smoothie",
    "snowflak",
    "playstat",
    "playboy1",
    "roadster",
    "hardware",
    "captain1",
    "undertak",
    "uuuuuuuu",
    "criminal",
    "1a2b3c4d",
    "thedoors",
    "annabell",
    "catwoman",
    "faithful",
    "farscape",
    "genesis1",
    "pumpkins",
    "training",
    "islander",
    "jamesbond",
    "19841984",
    "shitface",
    "maxwell1",
    "armstron",
    "alejandr",
    "augustus",
    "care1839",
    "fantasia",
    "freefall",
    "sandrine",
    "qwerqwer",
    "crystal1",
    "nineinch",
    "broncos1",
    "winston1",
    "warrior1",
    "iiiiiiii",
    "iloveyou2",
    "straight",
    "specialk",
    "tinkerbe",
    "jellybea",
    "cbr900rr",
    "gabriell",
    "gertrude",
    "glennwei",
    "sausages",
    "vanguard",
    "trinitro",
    "eldorado",
    "whiskers",
    "wildwood",
    "istheman",
    "interest",
    "25802580",
    "woodland",
    "strawber",
    "amsterdam",
    "catherine",
    "football1",
    "vancouve",
    "vauxhall",
    "acidburn",
    "myspace1",
    "buttercu",
    "minemine",
    "bigpoppa",
    "blackout",
    "blowfish",
    "talisman",
    "sundevil",
    "shanghai",
    "spencer1",
    "slowhand",
    "jonathon",
    "michaels",
    "resident",
    "redbaron",
    "andromed",
    "harddick",
    "5wr2i7h8",
    "charlotte",
    "fredrick",
    "francesc",
    "ferguson",
    "fairlane",
    "dogpound",
    "pornporn",
    "clippers",
    "daylight",
    "nnnnnnnn",
    "budapest",
    "whistler",
    "whatwhat",
    "wanderer",
    "idontkno",
    "thisisit",
    "robotics",
    "gonzalez",
    "drummer1",
    "private1",
    "cornwall",
    "christopher",
    "corvet07",
    "iverson3",
    "bluesman",
    "terminat",
    "johnson1",
    "bastards",
    "fuckoff1",
    "doomsday",
    "pornking",
    "bookworm",
    "highbury",
    "mischief",
    "ministry",
    "bigbooty",
    "yogibear",
    "september",
    "lkjhgfds",
    "123123123",
    "carpedie",
    "foxylady",
    "gatorade",
    "valdepen",
    "deadpool",
    "hotmail1",
    "kordell1",
    "vvvvvvvv",
    "jackson5",
    "bergkamp",
    "zanzibar",
    "services",
    "sheridan",
    "checkers",
    "luv2epus",
    "rainbow6",
    "qwerty123",
    "commande",
    "nightwin",
    "hotmail0",
    "enternow",
    "viewsoni",
    "berkeley",
    "woodstoc",
    "starstar",
    "patience",
    "hawaii50",
    "gorgeous",
    "challeng",
    "callisto",
    "firewall",
    "firefire",
    "passmast",
    "transfer",
    "clarissa",
    "moonshin",
    "jakejake",
    "bluejays",
    "southpark",
    "tomahawk",
    "leedsutd",
    "jermaine",
    "jeepster",
    "josephin",
    "matthias",
    "marriage",
    "antelope",
    "cabernet",
    "cheshire",
    "california",
    "fuckhead",
    "dominion",
    "trucking",
    "nostromo",
    "honolulu",
    "dynamite",
    "mollydog",
    "windows1",
    "washburn",
    "vincent1",
    "irishman",
    "bearcats",
    "sylveste",
    "marijuan",
    "reddwarf",
    "12312312",
    "hardball",
    "goldfing",
    "chambers",
    "fandango",
    "festival",
    "scrapper",
    "cromwell",
    "entrance",
    "klondike",
    "mohammed",
    "insomnia",
    "24682468",
    "24242424",
    "billbill",
    "blessing",
    "solitude",
    "pimpdadd",
    "johndeer",
    "babylove",
    "barbados",
    "carpente",
    "fishbone",
    "fireblad",
    "scissors",
    "screamer",
    "obsidian",
    "progress",
    "tottenham",
    "comanche",
    "monsters",
    "veronika",
    "20202020",
    "blueball",
    "yankees2",
    "wrestler",
    "sealteam",
    "sidekick",
    "smackdow",
    "sporting",
    "remingto",
    "arkansas",
    "andersen",
    "barcelona",
    "baltimor",
    "fortress",
    "fishfish",
    "firefigh",
    "rsalinas",
    "dontknow",
    "universa",
    "heinrich",
    "enforcer",
    "katherine",
    "waterboy",
    "23skidoo",
    "zildjian",
    "stoppedby",
    "sexybabe",
    "speakers",
    "polopolo",
    "perfect1",
    "thrasher",
    "lakeside",
    "masamune",
    "cherries",
    "chipmunk",
    "cezer121",
    "carnival",
    "fearless",
    "funstuff",
    "salasana",
    "pantera1",
    "qwert123",
    "creation",
    "nascar24",
    "estrella",
    "erection",
    "ericsson",
    "internal",
    "1michael",
    "19781978",
    "25252525",
    "sheepdog",
    "snowbird",
    "toriamos",
    "tennesse",
    "mazdarx7",
    "revolver",
    "babycake",
    "hallowee",
    "cannabis",
    "dolemite",
    "dodgers1",
    "painting",
    "coventry",
    "christmas",
    "cocksucker",
    "hotgirls",
    "eggplant",
    "mustang6",
    "monkey12",
    "wapapapa",
    "volleyba",
    "birthday4",
    "stephen1",
    "suburban",
    "soccer10",
    "something",
    "starcraft",
    "soccer12",
    "plastics",
    "penthous",
    "peterbil",
    "lakewood",
    "reginald",
    "goodgirl",
    "gotyoass",
    "capricor",
    "getmoney",
    "godfather",
    "gilligan",
    "dudedude",
    "pasadena",
    "opendoor",
    "magellan",
    "printing",
    "pressure",
    "killkill",
    "whiteboy",
    "voyager1",
    "jackjack",
    "success1",
    "spongebo",
    "phialpha",
    "password9",
    "tickling",
    "lexingky",
    "redheads",
    "apple123",
    "backbone",
    "aviation",
    "green123",
    "carlitos",
    "cartman1",
    "camaross",
    "favorite6",
    "ginscoot",
    "sabrina1",
    "devil666",
    "doughnut",
    "paintball",
    "rainbow1",
    "umbrella",
    "abc12345",
    "complete",
    "deerhunt",
    "darklord",
    "holidays",
    "hetfield",
    "hillbill",
    "hugetits",
    "evolutio",
    "whiplash",
    "wg8e3wjf",
    "istanbul",
    "bluebell",
    "wrestling",
    "superior",
    "suckdick",
    "stephane",
    "playball",
    "marcello",
    "marjorie",
    "rockwell",
    "baritone",
    "gladiator",
    "cricket1",
    "clemente",
    "exchange",
    "kisskiss",
    "kristian",
    "montecar",
    "mississi",
    "washington",
    "20012001",
    "bigdick1",
    "penguin1",
    "pathfind",
    "testibil",
    "lightning",
    "lighting",
    "republic",
    "anthony7",
    "goldeney",
    "cameron1",
    "freefree",
    "screwyou",
    "passthie",
    "postov1000",
    "puppydog",
    "a1234567",
    "cleopatr",
    "contract",
    "buffalo1",
    "bordeaux",
    "sunlight",
    "sprinter",
    "peaches1",
    "pinetree",
    "theforce",
    "jupiter1",
    "mckenzie",
    "annmarie",
    "austin31",
    "78945612",
    "calimero",
    "chevrolet",
    "favorite",
    "fellatio",
    "f00tball",
    "francine",
    "gateway2",
    "gamecube",
    "giovanna",
    "scheisse",
    "offshore",
    "macaroni",
    "pringles",
    "trouble1",
    "coolhand",
    "colonial",
    "darthvad",
    "cygnusx1",
    "natalie1",
    "eighteen",
    "elcamino",
    "blueberr",
    "yamahar1",
    "stafford",
    "snowboard",
    "speedway",
    "playboy2",
    "toonarmy",
    "mariposa",
    "baberuth",
    "gonzales",
    "chiquita",
    "charisma",
    "capslock",
    "cashmone",
    "gizmodo1",
    "dragonfl",
    "rachelle",
    "tropical",
    "crescent",
    "nathanie",
    "espresso",
    "kikimora",
    "20002000",
    "birthday1",
    "beatles1",
    "bigdicks",
    "beethove",
    "blacklab",
    "woodwork",
    "survivor",
    "pinnacle",
    "lemonade",
    "lalakers",
    "lebowski",
    "lalalala",
    "mercury1",
    "rocknrol",
    "riversid",
    "11112222",
    "alleycat",
    "ambrosia",
    "australia",
    "hattrick",
    "cassandr",
    "charlie123",
    "fighting",
    "gabriela",
    "outoutout",
    "pussy123",
    "randolph",
    "coldplay",
    "novifarm",
    "notredam",
    "honeybee",
    "wednesda",
    "waterfal",
    "billabon",
    "zachary1",
    "01234567",
    "superstar",
    "stiletto",
    "sigmachi",
    "somerset",
    "smithers",
    "playmate",
    "pinkfloyd",
    "laetitia",
    "revoluti",
    "archange",
    "handball",
    "chewbacc",
    "fullback",
    "dominiqu",
    "mandrake",
    "vagabond",
    "csfbr5yy",
    "deadspin",
    "ncc74656",
    "houston1",
    "hurricane",
    "horseman",
    "virginie",
    "idontknow",
    "151nxjmt",
    "bendover",
    "surprise",
    "supernov",
    "phantom1",
    "playoffs",
    "johngalt",
    "maserati",
    "riffraff",
    "architec",
    "cambridg",
    "foreplay",
    "sanity72",
    "salesman",
    "dreaming",
    "palmtree",
    "luckyone",
    "treefrog",
    "usmarine",
    "darkange",
    "cyclones",
    "bubba123",
    "building",
    "eclipse1",
    "kayleigh",
    "mustang2",
    "bigtruck",
    "yeahyeah",
    "stickman",
    "skipper1",
    "singapor",
    "southpaw",
    "slamdunk",
    "therock1",
    "tiger123",
    "mccarthy",
    "13576479",
    "greywolf",
    "candyass",
    "catfight",
    "frankie1",
    "qazwsxedc",
    "pregnant",
    "death666",
    "negative",
    "hooligan",
    "everlast",
    "mulligan",
    "motocros",
    "waterman",
    "inspiron",
    "bigblack",
    "zaq1xsw2",
    "yy5rbfsc",
    "takehana",
    "skydiver",
    "special1",
    "slimshad",
    "sopranos",
    "patches1",
    "thething",
    "mash4077",
    "matchbox",
    "14789632",
    "amethyst",
    "baseball1",
    "greenman",
    "goofball",
    "castillo",
    "capitals",
    "favorite2",
    "forsaken",
    "feelgood",
    "gfxqx686",
    "dilbert1",
    "dukeduke",
    "downhill",
    "longhair",
    "lockdown",
    "mamacita",
    "rainyday",
    "pumpkin1",
    "prospect",
    "rainbows",
    "trinity1",
    "trooper1",
    "citation",
    "bukowski",
    "bubbles1",
    "humphrey",
    "kcchiefs",
    "morticia",
    "montrose",
    "154ugeiu",
    "year2005",
    "wonderfu",
    "tampabay",
    "slapnuts",
    "spartan1",
    "sprocket",
    "sometime",
    "stanley1",
    "thinking",
    "lavalamp",
    "laserjet",
    "jediknig",
    "mazda626",
    "alexandra",
    "hairball",
    "graduate",
    "cartoons",
    "cashflow",
    "outsider",
    "mallrats",
    "primetime21",
    "valleywa",
    "abcdefg1",
    "natedogg",
    "nineball",
    "normandy",
    "nicetits",
    "buddy123",
    "highlife",
    "earthlin",
    "eatmenow",
    "kirkland",
    "money123",
    "warhamme",
    "instinct",
    "jackass1",
    "20spanks",
    "blackjack",
    "085tzzqi",
    "383pdjvl",
    "sparhawk",
    "pavement",
    "johnston",
    "material",
    "melanie1",
    "redlight",
    "aolsucks",
    "alexalex",
    "b929ezzh",
    "goodyear",
    "griffith",
    "863abgsg",
    "carebear",
    "checkmat",
    "forgetit",
    "rushmore",
    "question",
    "ptfe3xxp",
    "prophecy",
    "aircraft",
    "access99",
    "cocktail",
    "civilwar",
    "cleveland",
    "claudia1",
    "dapzu455",
    "daisydog",
    "eldiablo",
    "kingrich",
    "mudvayne",
    "vipergts",
    "italiano",
    "innocent",
    "yqlgr667",
    "zxcvbnm1",
    "suckcock",
    "stephens",
    "380zliki",
    "sexylady",
    "sixtynin",
    "sleeping",
    "sparkles",
    "letsdoit",
    "landmark",
    "marauder",
    "register",
    "basebal1",
    "azertyui",
    "hawkwind",
    "capetown",
    "flathead",
    "fisherma",
    "flipmode",
    "gabriel1",
    "dreamcas",
    "dirtydog",
    "dickdick",
    "destiny1",
    "trumpet1",
    "aaaaaaa1",
    "conquest",
    "creepers",
    "constant",
    "cornhole",
    "nirvana1",
    "elisabet",
    "musician",
    "milamber",
    "isacs155",
    "1million",
    "1letmein",
    "stonewal",
    "sexsexsex",
    "sonysony",
    "smirnoff",
    "pentagon",
    "paulpaul",
    "lighthou",
    "letmein22",
    "letmesee",
    "merchant",
    "redstorm",
    "14141414",
    "allison1",
    "basement",
    "hartford",
    "hardwood",
    "fatluvr69",
    "fidelity",
    "feathers",
    "gogators",
    "general1",
    "dragon69",
    "dragonball",
    "papillon",
    "optimist",
    "longshot",
    "undertow",
    "copenhag",
    "delldell",
    "culinary",
    "ibilltes",
    "hihje863",
    "envelope",
    "express1",
    "mustang5",
    "wellingt",
    "waterski",
    "infinite",
    "iloveyou!",
    "063dyjuy",
    "survival",
    "stockton",
    "softtail",
    "slimed123",
    "pizzaman",
    "pathetic",
    "tigercat",
    "jennings",
    "rootedit",
    "riverrat",
    "atreides",
    "happines",
    "chadwick",
    "ffvdj474",
    "foreskin",
    "gameover",
    "scoobydoo",
    "saxophon",
    "macintos",
    "lollypop",
    "qwertzui",
    "adelaide",
    "acapulco",
    "cybersex",
    "davecole",
    "davedave",
    "nineteen",
    "highlander",
    "kristin1",
    "knuckles",
    "katarina",
    "montana1",
    "wingchun",
    "watching",
    "illmatic",
    "bigpenis",
    "blue1234",
    "xxxxxxx1",
    "svetlana",
    "368ejhih",
    "playstation",
    "pescator",
    "jo9k2jw2",
    "jupiter2",
    "jurassic",
    "marines1",
    "14725836",
    "12345679",
    "alessand",
    "angelika",
    "alpha123",
    "barefeet",
    "badabing",
    "gsxr1000",
    "gregory1",
    "766rglqy",
    "69camaro",
    "calendar",
    "fishcake",
    "giuseppe",
    "gnasher23",
    "fuzzball",
    "save13tx",
    "russell1",
    "dripping",
    "dragon12",
    "dragster",
    "mainland",
    "poophead",
    "porn4life",
    "producer",
    "rapunzel",
    "velocity",
    "vanessa1",
    "trueblue",
    "vampire1",
    "navyseal",
    "nightowl",
    "nonenone",
    "nightmar",
    "bulletin",
    "hillside",
    "hzze929b",
    "hellohel",
    "edgewise",
    "embalmer",
    "excalibur",
    "mounta1n",
    "muffdive",
    "vivitron",
    "winfield",
    "wednesday",
    "17171717",
    "17011701",
    "tangerin",
    "stewart1",
    "summer69",
    "sweetness",
    "surveyor",
    "stirling",
    "ssptx452",
    "thriller",
    "master12",
    "anastasi",
    "almighty",
    "argentin",
    "flanders",
    "flyers88",
    "firehawk",
    "flashman",
    "godspeed",
    "giveitup",
    "funtimes",
    "frenchie",
    "disaster",
    "lovelife",
    "qcmfd454",
    "undertaker",
    "911turbo",
    "cristian",
    "daughter",
    "notebook",
    "borabora",
    "brisbane",
    "mohammad",
    "bettyboo",
    "blackice",
    "yvtte545",
    "tailgate",
    "shitshit",
    "sooners1",
    "smartass",
    "pennywis",
    "thetruth",
    "reindeer",
    "allstate",
    "greatest",
    "caldwell",
    "fussball",
    "geneviev",
    "samadams",
    "dipstick",
    "losangel",
    "loverman",
    "pussy4me",
    "university",
    "troubles",
    "churchil",
    "crazyman",
    "cutiepie",
    "bullwink",
    "bulldawg",
    "horsemen",
    "escalade",
    "minnesot",
    "moonlight",
    "mwq6qlzo",
    "verygood",
    "bellagio",
    "sickness",
    "skeeter1",
    "phaedrus",
    "thumper1",
    "tmjxn151",
    "thematri",
    "letmeinn",
    "jeffjeff",
    "johnmish",
    "11001001",
    "allnight",
    "amatuers",
    "attorney",
    "happyman",
    "graywolf",
    "474jdvff",
    "551scasi",
    "fishtank",
    "freewill",
    "glendale",
    "frogfrog",
    "gerhardt",
    "scirocco",
    "devilman",
    "pallmall",
    "lunchbox",
    "manhatta",
    "mandarin",
    "pxx3eftp",
    "president",
    "chris123",
    "daedalus",
    "natasha1",
    "nancy123",
    "nevermin",
    "newcastle",
    "edmonton",
    "monterey",
    "violator",
    "wildstar",
    "winter99",
    "iqzzt580",
    "19741974",
    "1q2w3e4r5t",
    "bigbucks",
    "blackcoc",
    "yesterda",
    "skinhead",
    "shadow12",
    "snapshot",
    "soccer11",
    "pleasant",
    "pimpdaddy",
    "lionhear",
    "littlema",
    "lincoln1",
    "laughing",
    "redshift",
    "12locked",
    "arizona1",
    "alfarome",
    "hawthorn",
    "goodfell",
    "554uzpad",
    "flipflop",
    "garrison",
    "rustydog",
    "sandberg",
    "samsung1",
    "dreamer1",
    "detectiv",
    "dominick",
    "paladin1",
    "papabear",
    "panasonic",
    "nyyankee",
    "pussyeat",
    "princeto",
    "climbing",
    "dad2ownu",
    "daredevi",
    "necklace",
    "huskers1",
    "hornyman",
    "england1",
    "motherfucker",
    "ilovegod",
    "201jedlz",
    "wrinkle5",
    "zoomzoom",
    "09876543",
    "starlite",
    "peternorth",
    "jeepjeep",
    "joystick",
    "junkmail",
    "jojojojo",
    "rockrock",
    "rasta220",
    "andyandy",
    "auckland",
    "gooseman",
    "happydog",
    "charlie2",
    "cardinals",
    "fortune12",
    "generals",
    "division",
    "ozlq6qwm",
    "macgyver",
    "mallorca",
    "prelude1",
    "trousers",
    "aerosmit",
    "clueless",
    "delpiero",
    "nounours",
    "buckaroo",
    "honeydew",
    "hooters1",
    "hugohugo",
    "evangeli", 
]);

// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./modules/Whitepapers/whitepapers.ts
var whitepapers = __webpack_require__(2275);
// EXTERNAL MODULE: ./utils/capitaliseFirstChar.ts
var capitaliseFirstChar = __webpack_require__(81754);
// EXTERNAL MODULE: ./utils/customisedYup.ts
var customisedYup = __webpack_require__(79427);
;// CONCATENATED MODULE: ./utils/isEmptyProperties.ts
function isEmptyProperties(obj) {
    for(var key in obj){
        if (obj[key] === null || obj[key] === "") {
            return true;
        }
    }
    return false;
}
/* harmony default export */ var utils_isEmptyProperties = (isEmptyProperties);

// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/dist/index.esm.js
var index_esm = __webpack_require__(96235);
;// CONCATENATED MODULE: ./assets/landingBg.png
/* harmony default export */ var landingBg = ({"src":"https://cdn.medrecruit.medworld.com/47c66d80968e67b163ad9ebdf45a607c4eaa72df/_next/static/media/landingBg.796cda65.png","height":902,"width":590,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAADFBMVEVVre43kd5JougvhdViUgRmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVQImSXKsQ0AMBCEMOD33zk6pXFlIOUbeNg8yUlcbIwHBCkAKkPMctsAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var dist_index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./utils/checkEmailStatus.ts




var checkEmailStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(email, cbFunc) {
        var result, emailHasBeenUsed;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,useRequest/* isUserExisting */.e3)(email)
                    ];
                case 1:
                    result = _state.sent();
                    emailHasBeenUsed = "response" in result ? result.response.data : false;
                    return [
                        2,
                        cbFunc ? cbFunc(emailHasBeenUsed) : emailHasBeenUsed
                    ];
            }
        });
    });
    return function checkEmailStatus(email, cbFunc) {
        return _ref.apply(this, arguments);
    };
}();
var debounceCheckEmailStatus = lodash_debounce_default()(checkEmailStatus, 300);

// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormGroup/FormGroup.js
var FormGroup = __webpack_require__(6562);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(96394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js
var Input = __webpack_require__(38799);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Visibility.js
var Visibility = __webpack_require__(20067);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(28270);
// EXTERNAL MODULE: ./components/BackgroundBannerImage/BackgroundBannerImage.tsx
var BackgroundBannerImage = __webpack_require__(64673);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/PhoneNumber/index.tsx
var PhoneNumber = __webpack_require__(81391);
// EXTERNAL MODULE: ./components/ProgressBarLayout/index.tsx
var ProgressBarLayout = __webpack_require__(55827);
// EXTERNAL MODULE: ./modules/RegistrationFlow/steps-old/RegisterBasicInfo/RegisterBasicInfo.module.scss
var RegisterBasicInfo_module = __webpack_require__(88051);
var RegisterBasicInfo_module_default = /*#__PURE__*/__webpack_require__.n(RegisterBasicInfo_module);
;// CONCATENATED MODULE: ./modules/RegistrationFlow/steps-old/RegisterBasicInfo/RegisterBasicInfo.tsx































var isLive = appClientConfig/* appClientConfig.isLive */.p.isLive;
var privacyPolicyUrl = appClientConfig/* appClientConfig.privacyPolicyUrl */.p.privacyPolicyUrl;
var defaultOverlayCenteredText = [
    "Together, let's",
    "open new doors",
    "for you."
];
var commonPasswordHint = "Your password is unsafe because it is too common. Choose a more unique password.";
var passwordLengthHint = "Min length is 8.";
var emailLengthHint = "Max length is 80.";
var firstNameLengthHint = "Max length is 40.";
var lastNameLengthHint = "Max length is 80.";
var registerSchema = customisedYup/* default.object */.Z.object().shape({
    email: customisedYup/* default.string */.Z.string().trim().max(80, emailLengthHint).required().emailValidation(),
    firstName: customisedYup/* default.string */.Z.string().trim().max(40, firstNameLengthHint).required(),
    lastName: customisedYup/* default.string */.Z.string().trim().max(80, lastNameLengthHint).required(),
    phone: PhoneNumber/* phoneNumberSchema */.aI,
    password: customisedYup/* default.string */.Z.string().trim().min(8, passwordLengthHint).notInDictionary(commonPasswords, commonPasswordHint).notContainsName().required()
});
var hasSubmitted = false;
var NOMAN_ASIF = "noman.asif@medenterprises.com";
// TODO: potentially have this be env specific and in parameter store
var MEMORIAM_URL = "https://profile.medworld.com/memoriam/noman";
var RegisterBasicInfo = function(param) {
    var onContinue = param.onContinue, formData = param.formData, preAction = param.preAction, previousRoute = param.previousRoute, whitepaperSlug = param.whitepaperSlug;
    var ref, ref1;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var router = (0,next_router.useRouter)();
    var signInRedirectUrl = (0,urlHelper/* getSignInUrlServerSide */.OV)(previousRoute, preAction);
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var defaultValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
        phone: "".concat(formData.phoneArea).concat(formData.phone),
        agreeTerms: false
    });
    var ref3 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,index_esm/* yupResolver */.Xp)(registerSchema),
        reValidateMode: "onChange",
        mode: "onChange",
        defaultValues: defaultValues
    }), handleSubmit = ref3.handleSubmit, errors = ref3.errors, getValues = ref3.getValues, register = ref3.register, control = ref3.control, setError = ref3.setError, watch = ref3.watch;
    var watchAgreeTerms = watch("agreeTerms");
    var changes = (0,dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "email"
    });
    (0,react.useEffect)(function() {
        var handleEmailCheck = function(emailHasBeenUsed) {
            emailHasBeenUsed && setError("email", {
                types: {
                    duplicated: true
                }
            });
        };
        changes && !errors.email && debounceCheckEmailStatus(changes, handleEmailCheck);
    }, [
        changes
    ]);
    (0,react.useEffect)(function() {
        hasSubmitted = false;
        return function() {
            if (!hasSubmitted) {
                var ref, ref1, ref2, ref3, ref4;
                var values = getValues();
                track("user left basic info flow page", {
                    first_name_entered: ((ref = values.firstName) === null || ref === void 0 ? void 0 : ref.length) > 0,
                    last_name_entered: ((ref1 = values.lastName) === null || ref1 === void 0 ? void 0 : ref1.length) > 0,
                    email_entered: ((ref2 = values.email) === null || ref2 === void 0 ? void 0 : ref2.length) > 0,
                    password_entered: ((ref3 = values.password) === null || ref3 === void 0 ? void 0 : ref3.length) > 0,
                    phone_entered: ((ref4 = values.phone) === null || ref4 === void 0 ? void 0 : ref4.length) > 0,
                    agree_terms_entered: values.agreeTerms
                });
            }
        };
    }, []);
    var handleClickPwEye = function() {
        return setShowPassword(!showPassword);
    };
    var handleMouseDownPassword = function(event) {
        event.preventDefault();
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var initialData, clientId, agreeTerms, rest;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        initialData = {
                            email: data.email,
                            firstName: data.firstName,
                            lastName: data.lastName,
                            phone: data.phone
                        };
                        if (isLive) {
                            try {
                                clientId = ga.getAll()[0].get("clientId");
                                if (clientId) {
                                    initialData.gaClientId = clientId;
                                }
                            } catch (err) {
                                console.error("failed to add GA client id", err);
                            }
                        }
                        return [
                            4,
                            (0,useRequest/* sendBasicInfo */.Qh)(initialData)
                        ];
                    case 1:
                        _state.sent();
                        hasSubmitted = true;
                        agreeTerms = data.agreeTerms, rest = (0,_object_without_properties/* default */.Z)(data, [
                            "agreeTerms"
                        ]);
                        onContinue(rest);
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var getBasicInfoTitleWithUniversalLogin = function() {
        var signInRedirectUrl = (0,urlHelper/* getSignInUrlServerSide */.OV)(previousRoute, preAction);
        var mainTitleText = "";
        switch(preAction){
            case "enquire_job":
                mainTitleText = "To enquire about this job, you’ll first need to register to create an account or";
                break;
            case "save_job":
                mainTitleText = "To save this job listing, you’ll first need to register to create an account or";
                break;
            case "create_job_alert":
                mainTitleText = "To save this job alert, you’ll first need to register to create an account or";
                break;
            case "whitepaper":
                mainTitleText = "To access this resource, you’ll first need to register to create an account or";
                break;
            default:
                mainTitleText = "Register for an account, or";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            "data-testid": "mainTitle_ul",
            children: [
                mainTitleText,
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    "data-testid": "mainTitle_signup",
                    href: signInRedirectUrl,
                    children: "sign in"
                }),
                "."
            ]
        });
    };
    var values = getValues();
    var disabledSubmit = Object.keys(errors).length > 0 || utils_isEmptyProperties(values) || !watchAgreeTerms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RegisterBasicInfo_module_default()).consistentSpacing
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBarLayout/* ProgressBarLayout */.F, {
                divide: true,
                leftContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* ImageContainer */.mo, {
                    height: 903,
                    width: 593,
                    img: landingBg,
                    overlayCenteredText: whitepaperSlug ? ((ref = whitepapers/* whitepapers.get */.j.get(whitepaperSlug)) === null || ref === void 0 ? void 0 : ref.textOverlay) || defaultOverlayCenteredText : defaultOverlayCenteredText
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (RegisterBasicInfo_module_default()).formContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RegisterBasicInfo_module_default()).bannerContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (RegisterBasicInfo_module_default()).banner,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundBannerImage/* BackgroundBannerImage */.M, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (RegisterBasicInfo_module_default()).smTitle__ul,
                                            children: "Welcome to Medrecruit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            component: "h1",
                                            className: (RegisterBasicInfo_module_default()).invisible,
                                            children: "Let's get you on board"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (RegisterBasicInfo_module_default()).mainTitle__ul,
                                            children: getBasicInfoTitleWithUniversalLogin()
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: (RegisterBasicInfo_module_default()).formContent,
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (RegisterBasicInfo_module_default()).nameInputs,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "firstName",
                                            control: control,
                                            render: function(param) {
                                                var onChange = param.onChange, onBlur = param.onBlur, value = param.value;
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    name: "firstName",
                                                    label: "First Name",
                                                    inputProps: {
                                                        "data-testid": "first-name"
                                                    },
                                                    fullWidth: true,
                                                    error: !!errors.firstName,
                                                    helperText: (ref = errors.firstName) === null || ref === void 0 ? void 0 : ref.message,
                                                    onBlur: onBlur,
                                                    onChange: function(e) {
                                                        var val = (0,capitaliseFirstChar/* capitaliseFirstChar */.f)(e.target.value);
                                                        onChange(val);
                                                    },
                                                    value: value || ""
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "lastName",
                                            control: control,
                                            render: function(param) {
                                                var onChange = param.onChange, onBlur = param.onBlur, value = param.value;
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    name: "lastName",
                                                    label: "Last Name",
                                                    inputProps: {
                                                        "data-testid": "last-name"
                                                    },
                                                    fullWidth: true,
                                                    onBlur: onBlur,
                                                    error: !!errors.lastName,
                                                    helperText: (ref = errors.lastName) === null || ref === void 0 ? void 0 : ref.message,
                                                    onChange: function(e) {
                                                        var val = (0,capitaliseFirstChar/* capitaliseFirstChar */.f)(e.target.value);
                                                        onChange(val);
                                                    },
                                                    value: value || ""
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (RegisterBasicInfo_module_default()).accountInputs,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "email",
                                            control: control,
                                            render: function(param) {
                                                var onChange = param.onChange;
                                                var ref, ref1, ref2;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    className: (RegisterBasicInfo_module_default()).input,
                                                    name: "email",
                                                    label: "Email",
                                                    inputProps: {
                                                        "data-testid": "register-email"
                                                    },
                                                    autoComplete: "username email",
                                                    inputRef: register,
                                                    onChange: function(e) {
                                                        onChange(e);
                                                        if (e.target.value === NOMAN_ASIF) {
                                                            // trigger Noman's easter egg
                                                            router.push(MEMORIAM_URL);
                                                            return;
                                                        }
                                                    },
                                                    fullWidth: true,
                                                    error: !!errors.email,
                                                    helperText: ((ref = errors.email) === null || ref === void 0 ? void 0 : (ref1 = ref.types) === null || ref1 === void 0 ? void 0 : ref1.duplicated) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "Email has already been registered, please sign in ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                prefetch: false,
                                                                href: signInRedirectUrl,
                                                                as: signInRedirectUrl,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: "here"
                                                                })
                                                            })
                                                        ]
                                                    }) || ((ref2 = errors.email) === null || ref2 === void 0 ? void 0 : ref2.message),
                                                    defaultValue: formData === null || formData === void 0 ? void 0 : formData.email
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                            className: (RegisterBasicInfo_module_default()).input,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                fullWidth: true,
                                                error: !!errors.password,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                        htmlFor: "standard-adornment-password",
                                                        children: "Password"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                                        name: "password",
                                                        control: control,
                                                        render: function(param) {
                                                            var onChange = param.onChange;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                id: "standard-adornment-password",
                                                                inputProps: {
                                                                    "data-testid": "register-password"
                                                                },
                                                                autoComplete: "new-password",
                                                                type: showPassword ? "text" : "password",
                                                                name: "password",
                                                                "aria-describedby": "password",
                                                                inputRef: register,
                                                                onChange: onChange,
                                                                fullWidth: true,
                                                                error: !!errors.password,
                                                                defaultValue: formData === null || formData === void 0 ? void 0 : formData.password,
                                                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                                    position: "end",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                        "aria-label": "toggle password visibility",
                                                                        onClick: handleClickPwEye,
                                                                        onMouseDown: handleMouseDownPassword,
                                                                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {})
                                                                    })
                                                                })
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        "data-testid": "password-error-msg",
                                                        children: (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                            row: true,
                                            className: (RegisterBasicInfo_module_default()).input,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                                name: "phone",
                                                control: control,
                                                render: function(param) {
                                                    var onChange = param.onChange;
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(PhoneNumber/* PhoneNumber */.Bh, {
                                                        phoneNumber: formData.phone,
                                                        area: formData.phoneArea,
                                                        error: (ref = errors.phone) === null || ref === void 0 ? void 0 : ref.message,
                                                        onChange: function(param) {
                                                            var mixPhone = param.mixPhone;
                                                            onChange(mixPhone);
                                                        }
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (RegisterBasicInfo_module_default()).termsContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                                    name: "agreeTerms",
                                                    control: control,
                                                    render: function(param) {
                                                        var onChange = param.onChange, value = param.value;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            checked: value,
                                                            color: "primary",
                                                            onChange: function() {
                                                                return onChange(!value);
                                                            },
                                                            inputProps: {
                                                                "aria-label": "secondary checkbox",
                                                                className: (RegisterBasicInfo_module_default()).checkbox__input,
                                                                "data-testid": "agree-terms"
                                                            }
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (RegisterBasicInfo_module_default()).terms,
                                                    children: [
                                                        "I agree to the",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            prefetch: false,
                                                            href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                                                            as: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (RegisterBasicInfo_module_default()).link,
                                                                href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                                                                children: "terms and conditions"
                                                            })
                                                        }),
                                                        " ",
                                                        "and",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            prefetch: false,
                                                            href: privacyPolicyUrl,
                                                            as: privacyPolicyUrl,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (RegisterBasicInfo_module_default()).link,
                                                                href: privacyPolicyUrl,
                                                                children: "privacy policy"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    "data-testid": "continue-button-page-1",
                                    disabled: disabledSubmit,
                                    color: "secondary",
                                    fullWidth: true,
                                    size: "large",
                                    variant: "contained",
                                    children: "Register to continue"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "data-testid": "register-sign-in",
                                    className: (RegisterBasicInfo_module_default()).gotoSignin,
                                    fullWidth: true,
                                    size: "large",
                                    color: "secondary",
                                    variant: "outlined",
                                    href: signInRedirectUrl,
                                    children: "Sign in with existing account"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var RegisterBasicInfo_RegisterBasicInfo = (RegisterBasicInfo);


/***/ }),

/***/ 2275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ whitepapers; }
/* harmony export */ });
/**
 * The currently supported whitepapers; may be replaced by CMS config in future
 */ /**
 * Data about all supported whitepapers
 */ var whitepapers = new Map([
    [
        "job-market-report-australia",
        {
            name: "Job Market Report Australia",
            description: "Download our Free Australian Doctor Job Market Report. Free job market report packed with information for doctors in Australia. Find out what is having an impact on Australian healthcare today, where the work is, what specialties are in demand, and average pay rates for locum and permanent roles across the country.",
            textOverlay: [
                "Find out the",
                "hottest locations",
                "and highest rates",
                "for doctors in",
                "Australia right now.", 
            ]
        }, 
    ],
    [
        "job-market-report-new-zealand",
        {
            name: "Job Market Report NZ",
            description: "Download our Free New Zealand Doctor Job Market Report. Free job market report packed with information for doctors in New Zealand. Find out what is having an impact on New Zealand healthcare today, where the work is, what specialties are in demand, and average pay rates for locum and permanent roles across the country.",
            textOverlay: [
                "Find out the best",
                "rates, and in-demand",
                "locations for doctors in",
                "New Zealand right now.", 
            ]
        }, 
    ],
    [
        "cv-template",
        {
            name: "CV Template",
            description: "Download our Free Editable Doctor CV Template. A doctor’s curriculum vitae is one of the most important tools in their job search arsenal. This CV template, specifically designed for doctors, will help make sure you have everything you need on yours to apply for (and get) great new roles",
            textOverlay: [
                "Let's ensure",
                "your CV is",
                "right for the job."
            ]
        }, 
    ],
    [
        "international-doctor-guide",
        {
            name: "INTL Guide",
            description: "Your free Guide to Working Down Under as an International Medical Graduate is packed with information for IMGs looking to make the move to Australia or New Zealand. Find out what residence pathway is right for you, where the work is and what the rates are, and what your new lifestyle down under could be like.",
            textOverlay: [
                "Find out everything",
                "you need to know",
                "about working as a doctor",
                "in Australia and New Zealand", 
            ]
        }, 
    ],
    [
        "interview-guide",
        {
            name: "Interview Guide",
            description: "Download our Free Doctor Interview Guide. Packed with common questions and answers to help you nail your next interview.",
            textOverlay: [
                "Get the insider",
                "tips and tricks",
                "to nail your",
                "next doctor job interview.", 
            ]
        }, 
    ], 
]);


/***/ }),

/***/ 81754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ capitaliseFirstChar; }
/* harmony export */ });
function capitaliseFirstChar(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}


/***/ }),

/***/ 79427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emailIsInvalid */
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48966);
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(validator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16310);


var emailIsInvalid = "Email is invalid";
yup__WEBPACK_IMPORTED_MODULE_0__.addMethod(yup__WEBPACK_IMPORTED_MODULE_0__.string, "emailValidation", function(message) {
    return this.test("emailValidator", message !== null && message !== void 0 ? message : emailIsInvalid, function(value) {
        return value && validator__WEBPACK_IMPORTED_MODULE_1___default().isEmail(value);
    });
});
yup__WEBPACK_IMPORTED_MODULE_0__.addMethod(yup__WEBPACK_IMPORTED_MODULE_0__.string, "notContainsName", function() {
    return this.test("notContainsName", "Your password must not contain your first name or last name.", function(value) {
        if (!value) {
            return true;
        }
        var names = [];
        this.parent.firstName && names.push(this.parent.firstName);
        this.parent.lastName && names.push(this.parent.lastName);
        if (names.length === 0) {
            return true;
        }
        var pattern = names.join("|");
        var index = value.search(new RegExp(pattern, "i"));
        return index === -1;
    });
});
yup__WEBPACK_IMPORTED_MODULE_0__.addMethod(yup__WEBPACK_IMPORTED_MODULE_0__.string, "notInDictionary", function(dictionary, message) {
    return this.test("notInDictionary", message, function(value) {
        return !value || !dictionary.has(value === null || value === void 0 ? void 0 : value.toLowerCase());
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (yup__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ 56411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"phoneArea":"style_phoneArea__fH23X","phoneNumber":"style_phoneNumber__bzWVP"};

/***/ }),

/***/ 6117:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__PYUvO","progressBar":"style_progressBar__AgK4Z","content":"style_content__a0Icn","rightContent":"style_rightContent__yr1bD","leftContent":"style_leftContent__pk_1p","blueBackground":"style_blueBackground__2JGSX"};

/***/ }),

/***/ 88051:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"RegisterBasicInfo_formContainer__TJIAH","smTitle__ul":"RegisterBasicInfo_smTitle__ul__gSTaE","mainTitle__ul":"RegisterBasicInfo_mainTitle__ul__0TJdg","invisible":"RegisterBasicInfo_invisible__8_QSo","input":"RegisterBasicInfo_input__DUsJT","nameInputs":"RegisterBasicInfo_nameInputs__LyAFE","accountInputs":"RegisterBasicInfo_accountInputs__EJ7D9","link":"RegisterBasicInfo_link__Kp8xj","terms":"RegisterBasicInfo_terms__LHoIC","bannerContainer":"RegisterBasicInfo_bannerContainer__z1_46","banner":"RegisterBasicInfo_banner__8dbms","formContent":"RegisterBasicInfo_formContent__3E4_X","consistentSpacing":"RegisterBasicInfo_consistentSpacing__726Nz","termsContainer":"RegisterBasicInfo_termsContainer__hJTWC","checkbox__input":"RegisterBasicInfo_checkbox__input__bj_aN","gotoSignin":"RegisterBasicInfo_gotoSignin__70px3"};

/***/ })

}]);